window.addEventListener("load", (event) => {
    var title_judgme = document.querySelector('#judgeme_product_reviews .jm-review-widget__header .jm-review-widget-header__title');
    if ( title_judgme ){
        title_judgme.innerHTML = title_judgme.textContent.replace("Clients","<em>Clients</em>");
    }

    setTimeout(function () {
      var title_instafeed = document.querySelector('#insta-feed>h2');
      if ( title_instafeed ){
          title_instafeed.innerHTML = title_instafeed.textContent.replace('@SALONGRPARIS','<a href="https://www.instagram.com/salongrparis/" target="_blank">@SALONGRPARIS</a>');
      }
    }, 1000);
});



function patchGallerySwiper() {
  const el = document.querySelector('.swiper-wrapper-main');
  if (!el?.swiper) return false;
  if (window.innerWidth > 767) return true;

  const swiper = el.swiper;
  swiper.params.slidesPerView = 'auto';
  swiper.update();
  swiper.slideTo(swiper.activeIndex, 0);
  return true;
}

const observer = new MutationObserver(() => {
  if (patchGallerySwiper()) observer.disconnect();
});

observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });